const moldovaNodes: Array<[string, number]> = [
  ["Energy", 150],
  ["Agriculture", 214],
  ["Food & Wine", 278],
  ["Communities", 342]
];

const pathwayNodes: Array<[string, number]> = [
  ["Technology", 205],
  ["Expertise", 265],
  ["Finance", 325]
];

export function CorridorDiagram() {
  return (
    <svg viewBox="0 0 620 520" role="img" aria-label="A corridor from Moldova needs, through Transition Bridge, to implementation pathways supported by research and institutions." className="h-auto w-full select-none">
      <defs>
        <linearGradient id="corridorFlow" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#2457f5" />
          <stop offset="50%" stopColor="#12afcb" />
          <stop offset="100%" stopColor="#28c98b" />
        </linearGradient>
        <radialGradient id="hubGlow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#2457f5" stopOpacity="0.20" />
          <stop offset="60%" stopColor="#12afcb" stopOpacity="0.10" />
          <stop offset="100%" stopColor="#2457f5" stopOpacity="0" />
        </radialGradient>
        <clipPath id="emblemClip"><circle cx="0" cy="0" r="40" /></clipPath>
      </defs>

      {/* atmospheric glow behind the hub */}
      <circle className="diagram-glow" cx="315" cy="255" r="180" fill="url(#hubGlow)" />

      {/* supporting baseline: research · institutions */}
      <g className="text-[9px] font-semibold tracking-[0.2em]">
        <line x1="96" y1="470" x2="524" y2="470" stroke="#c2cfd7" strokeWidth="1.5" />
        <text x="315" y="446" textAnchor="middle" className="fill-[#56616D]">RESEARCH</text>
        <text x="315" y="446" dx="60" textAnchor="middle" className="fill-[#56616D]">·</text>
        <text x="315" y="446" dx="120" textAnchor="middle" className="fill-[#56616D]">INSTITUTIONS</text>
        <text x="315" y="488" textAnchor="middle" className="fill-[#56616D] uppercase">Supporting layer</text>
      </g>

      {/* club vertical connectors */}
      <line x1="150" y1="146" x2="150" y2="352" stroke="#c2cfd7" strokeWidth="1.5" strokeDasharray="2 6" />
      <line x1="488" y1="202" x2="488" y2="330" stroke="#c2cfd7" strokeWidth="1.5" strokeDasharray="2 6" />

      {/* corridor base line */}
      <path d="M150 265 C 220 235, 260 245, 315 255 C 370 265, 420 245, 488 240" fill="none" stroke="#c2cfd7" strokeWidth="2" />
      {/* corridor flow overlay */}
      <path d="M150 265 C 220 235, 260 245, 315 255 C 370 265, 420 245, 488 240" fill="none" stroke="url(#corridorFlow)" strokeWidth="2.5" strokeLinecap="round" className="diagram-flow" strokeDasharray="6 14" opacity="0.85" />

      {/* Moldova needs nodes */}
      <g className="text-[11px] font-semibold">
        <text x="120" y="42" textAnchor="middle" className="fill-[#1B2730] uppercase tracking-[0.16em] text-[10px]">Moldova needs</text>
        {moldovaNodes.map(([label, y]) => (
          <g key={label}>
            <line x1="136" y1={y} x2="162" y2={y} stroke="#12afcb" strokeWidth="1.6" opacity="0.85" />
            <circle cx="164" cy={y} r="5" fill="#fcfaf4" stroke="#12afcb" strokeWidth="2" />
            <text x="182" y={y + 4} textAnchor="start" className="fill-[#56616D]">{label}</text>
          </g>
        ))}
      </g>

      {/* Implementation pathway nodes */}
      <g className="text-[11px] font-semibold">
        <text x="488" y="180" textAnchor="middle" className="fill-[#1B2730] uppercase tracking-[0.16em] text-[10px]">Implementation</text>
        <text x="488" y="194" textAnchor="middle" className="fill-[#1B2730] uppercase tracking-[0.16em] text-[10px]">pathways</text>
        {pathwayNodes.map(([label, y]) => (
          <g key={label}>
            <line x1="474" y1={y} x2="460" y2={y} stroke="#2457f5" strokeWidth="1.6" opacity="0.8" />
            <circle cx="458" cy={y} r="5" fill="#fcfaf4" stroke="#2457f5" strokeWidth="2" />
            <text x="440" y={y + 4} textAnchor="end" className="fill-[#56616D]">{label}</text>
          </g>
        ))}
      </g>

      {/* central Transition Bridge emblem */}
      <g transform="translate(315 255)">
        <circle className="diagram-float" r="58" fill="none" stroke="#2457f5" strokeOpacity="0.22" strokeDasharray="2 6" />
        <circle r="44" fill="#2457f5" fillOpacity="0.06" />
        <image href="/branding/transition-bridge-mark.png" x="-40" y="-40" width="80" height="80" clipPath="url(#emblemClip)" preserveAspectRatio="xMidYMid slice" />
      </g>
    </svg>
  );
}
